import { createFileRoute } from '@tanstack/react-router';
import { SkillForm } from '@/components/skills/form/SkillForm.tsx';

export const Route = createFileRoute('/_app/skills/$id/edit')({
  staticData: { orgScope: 'none' },
  component: SkillEditRoute,
});

function SkillEditRoute() {
  const { id } = Route.useParams();
  return <SkillForm skillId={id} />;
}
